import React from 'react';
import { LinearProgress as MuiLinearProgress } from '@mui/material';

export const LinearProgress = () => {
  return <MuiLinearProgress />;
};

export default LinearProgress;
